import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  // Mensaje claro en vez de un fallo raro en el primer fetch.
  throw new Error("Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (ver .env.example).");
}

// La anon key es pública por diseño: la seguridad vive en RLS y en las funciones SQL.
export const supabase = createClient<Database>(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export type Tablas = Database["public"]["Tables"];
export type Vistas = Database["public"]["Views"];
export type Funciones = Database["public"]["Functions"];
export type Enums = Database["public"]["Enums"];
export type Existencia = Vistas["v_existencias"]["Row"];
export type HistorialFila = Vistas["v_historial"]["Row"];
export type ZonaResumen = Vistas["v_zonas_ultimo_conteo"]["Row"];
export type Almacen = Tablas["almacenes"]["Row"];
export type Zona = Tablas["zonas"]["Row"];
export type Empresa = Tablas["empresas"]["Row"];
export type UsuarioEmpresa = Tablas["usuarios_empresa"]["Row"];
export type Rol = Enums["rol_usuario"];
export type MotivoMovimiento = Enums["motivo_movimiento"];
export type TipoMovimiento = Enums["tipo_movimiento"];
